module.exports = __webpack_public_path__ + "static/media/a10.39366e13.jpg";